var Popups = function(params) {
	var _this = this,
		_appPromoPopupShowAfter = 6,
		_popupCookieValidDays = 7;

	function _setAppPromoPopup() {
		var cookieCnt = Cookies.get(ViewConsts.CookieKeys.vwAppPop),
			showPopup = true;

		if (typeof cookieCnt !== 'undefined') {
			showPopup = false;
			// cookieCnt = parseInt(cookieCnt);

			// if (cookieCnt < _appPromoPopupShowAfter) {
			// 	showPopup = false;
			// 	cookieCnt++;
				
			// 	Cookies.set(ViewConsts.CookieKeys.vwAppPop, cookieCnt, { expires: _popupCookieValidDays });
			// } else {
			// 	Cookies.remove(ViewConsts.CookieKeys.vwAppPop);
			// }
		}


		if (showPopup) {
			_show('.view-popup.popup-app-promo', 300, 1, function() {
				$(this).find('map').imageMapResize();
			});
		}

		$(document).on('click', '.view-popup .popup-close, .view-popup.vp-click-to-close', function(e) {
			e.preventDefault();
			
			var $el = $(this);

			if ($el.hasClass('.view-popup')) {
				$el.fadeOut(100);
			} else {
				$el.closest('.view-popup').fadeOut(100);
			}

			if (typeof Cookies.get(ViewConsts.CookieKeys.vwAppPop) === 'undefined') {
				Cookies.set(ViewConsts.CookieKeys.vwAppPop, 1, { expires: 7 });
			}
		});

		var debouncedResizePopup = dom.debounce(function(){
			$('.view-popup.popup-app-promo').find('map').imageMapResize();
		}, 500);

		$(window).on('resize', debouncedResizePopup);
	}

	function _show(selector, time, opacity, callback) {
		time = time || 300;
		opacity = opacity || 1;

		$(selector).fadeTo(time, opacity, function() {
			if (typeof callback !== 'undefined' && typeof callback === 'function') {
				callback();
			}
		});
	}

	function _init() {
		if (viewConfig.check('hasAppPromoPage')) {
			window.addEventListener('view.app.promo.show.popup', _setAppPromoPopup);
		}
	}

	_this.init = _init;
};